import React from 'react';
import { ShortcutButtons } from './widgets';
import './text-collapse.less';

const TextCollapse: React.FC = () => {
    return (
        <div className="c-text-collapse">
            <div style={{ height: '100%', display: 'block' }}>
                <div style={{ width: '100%', marginLeft: 6 }}>
                    <ShortcutButtons />
                </div>
            </div>
        </div>
    );
};

export default React.memo(TextCollapse);
